// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// --- HS Code
import { TrackMyJourneyResultsModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-comparison-results-filter',
  templateUrl: './comparison-results-filter.component.html',
  styleUrls: ['./comparison-results-filter.component.scss'],
})
export class ComparisonResultsFilterComponent {
  @Input() compareReportResults: TrackMyJourneyResultsModel[] | null = null;

  @Output() filterClick = new EventEmitter<string>();

  onFilterClick() {
    this.filterClick.emit();
  }
}
